import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Container } from '../Container';
import { GridLines } from '../GridLines';
import { Reveal } from '../Reveal';
import { site } from '../../data/site';

/** Off-black paper grain, drawn rather than photographed so it tiles cleanly at any size. */
const paperGrain = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='180'%3E%3Cfilter id='g'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='180' height='180' filter='url(%23g)'/%3E%3C/svg%3E\")";
const trustLines = [{
  label: 'Response time',
  value: 'within one working day'
}, {
  label: 'Pricing',
  value: 'fixed before work starts'
}, {
  label: 'Based in India',
  value: 'working remotely'
}];
export function CtaBand() {
  return <section aria-labelledby="cta-title" className="relative isolate overflow-hidden bg-ink py-20 text-white lg:py-[160px]" data-id="element-452" data-mp="ot2zdg2mt3me">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-0 opacity-[0.08]" style={{
      backgroundImage: paperGrain,
      backgroundRepeat: 'repeat'
    }} data-id="element-453" data-mp="2cdribw23ossg" />
      <GridLines tone="dark" data-id="element-454" data-mp="22mwvoqkxzr6h" />

      <Container className="relative z-10" data-id="element-455" data-mp="1xpenj2er1fzj">
        <div className="grid gap-14 lg:grid-cols-[1fr_260px] lg:items-start lg:gap-16" data-id="element-456" data-mp="1xode12ddt1jx">
          <Reveal data-id="element-457" data-mp="1to34jfqdrt0b">
            <h2 id="cta-title" className="max-w-[22ch] text-[clamp(56px,7vw,104px)] font-normal leading-[0.98] tracking-[-0.03em] text-white" data-id="element-458" data-mp="1tol2cgsoyfac">
              Let&rsquo;s make your company look like what it already is.
            </h2>

            <Link to="/contact" className="group mt-12 inline-flex h-12 items-center justify-center rounded-card bg-white px-6 text-small font-medium text-ink transition-[padding] duration-200 ease-out hover:px-8" data-id="element-459" data-mp="1erc5j7kmcjb8">
              Start a Project
              <ArrowRightIcon size={16} aria-hidden="true" className="ml-0 w-0 -translate-x-2 opacity-0 transition-[transform,opacity,margin-left,width] duration-200 ease-out group-hover:ml-2 group-hover:w-4 group-hover:translate-x-0 group-hover:opacity-100" data-id="element-460" data-mp="17ew48ysk8qid" />
            </Link>
          </Reveal>

          <Reveal delay={0.08} data-id="element-461" data-mp="12e8fkjrt0lrb">
            <ul className="divide-y divide-[#262626] border-t border-[#262626] lg:mt-3" data-id="element-462" data-mp="1q65ghftpttdn">
              {trustLines.map(item => <li key={item.label} className="py-4" data-id="element-463" data-mp="1v3nq78fk4cmp">
                  <p className="text-[14px] leading-6 text-[#8A8A8A]" data-id="element-464" data-mp="1h5hb19ie11cd">
                    {item.label} <span aria-hidden="true" data-id="element-465" data-mp="1h7jwdg8li6ar">—</span> {item.value}
                  </p>
                </li>)}
            </ul>
          </Reveal>
        </div>
      </Container>

      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 z-0 flex translate-y-1/2 select-none justify-center" data-id="element-466" data-mp="5s54urz5o6n1">
        <span className="font-serif text-[200px] font-normal uppercase leading-none tracking-tight text-transparent [-webkit-text-stroke:1px_#262626]" data-id="element-467" data-mp="26tibuwy6hy7">
          {site.shortName}
        </span>
      </div>
    </section>;
}